import {useEffect, useState} from 'react';
import {GetVisitDetailsUseCase} from '../../visits/useCases/GetVisitDetailsUseCase';
import type {Visit} from '../../visits/models/visit.model';

interface UseVisitDetailResult {
  visit: Visit | null;
  loading: boolean;
  error: string | null;
}

/**
 * Fetches a single visit by ID. Driven by the marketer-tracking map —
 * `visitId` becomes non-null when the user clicks a store marker on the
 * path. Cleared by passing null.
 */
export const useVisitDetail = (visitId: number | null): UseVisitDetailResult => {
  const [visit, setVisit] = useState<Visit | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (visitId === null) {
      setVisit(null);
      setError(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    const useCase = new GetVisitDetailsUseCase();
    useCase
      .execute(visitId)
      .then((data) => {
        if (cancelled) return;
        setVisit(data);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        const msg = err instanceof Error ? err.message : 'تعذّر تحميل تفاصيل الزيارة';
        setError(msg);
        setVisit(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [visitId]);

  return {visit, loading, error};
};
